import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import useRewardsTimeRemaining from '~/acquisition/utils/useRewardsTimeRemaining';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Container = styled.span`
  margin-left: 5px;
  color: ${({ theme }) => theme.colors.alertRed};
`;

export default function PlatinumCountdown({ className, dataAutotag }) {
  const { results } = useRewardsTimeRemaining();
  const { dateTimeRemaining, dateAbbreviation } = results;

  return (
    <Container className={className} data-autotag={dataAutotag}>
      {dateTimeRemaining}{' '}
      {dateAbbreviation?.id && <FormattedMessage {...dateAbbreviation} />}
    </Container>
  );
}

PlatinumCountdown.propTypes = {
  className: PropTypes.string,
  dataAutotag: PropTypes.string,
};
